import { render, staticRenderFns } from "./names.vue?vue&type=template&id=21d44f7e&scoped=true&"
import script from "./names.vue?vue&type=script&lang=js&"
export * from "./names.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d44f7e",
  null
  
)

export default component.exports